import { render, staticRenderFns } from "./logo-slider.vue?vue&type=template&id=5cf1b5f4"
import script from "./logo-slider.vue?vue&type=script&lang=js"
export * from "./logo-slider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports